import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import loadBackendStatus from 'redux/actions/backendStatus/loadBackendStatus';
var runAnndata = function runAnndata(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/anndata"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 3:
            _context.next = 5;
            return dispatch(loadBackendStatus(experimentId));
          case 5:
            return _context.abrupt("return", true);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_STARTING_PIPLELINE);
            if (!(errorMessage !== endUserMessages.ERROR_NO_PERMISSIONS)) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return dispatch(loadBackendStatus(experimentId));
          case 14:
            return _context.abrupt("return", false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default runAnndata;